import React from "react";
import { Col, Row, Button, Table, Form ,Container} from "react-bootstrap";
import { Link } from "react-router-dom";

const Payments = () => {
  const paymentData = [
    {
      id: 1,
      role: "Admin",
      chapter: "abcf dd",
      control_number: "22122",
      type: "member",
      status: "Alabama",
      payment: "8888",
      amount: "10002",
    },
    {
      id: 2,
      role: "super Admin",
      chapter: "chapter name",
      control_number: "66444",
      type: "member",
      status: "Alabama",
      payment: "8888",
      amount: "10002",
    },
    {
      id: 3,
      role: "Guest",
      chapter: "data here",
      control_number: "2244",
      type: "member",
      status: "Alabama",
      payment: "8888",
      amount: "10002",
    },
    {
      id: 4,
      role: "Admin",
      chapter: "name here",
      control_number: "35552",
      type: "member",
      status: "Alabama",
      payment: "8888",
      amount: "10002",
    },
    {
      id: 5,
      role: "Controller",
      chapter: "dafda",
      control_number: "34332",
      type: "member",
      status: "Alabama",
      payment: "8888",
      amount: "10002",
    },
    {
      id: 6,
      role: "Guest",
      chapter: "chap name",
      control_number: "2355",
      type: "member",
      status: "Alabama",
      payment: "8888",
      amount: "10002",
    },
  ];

  return (
    <>
     <Container fluid>
      <Row className="mb-2">
        <Col className="d-flex justify-content-end">
          <Link to="/">
            <Button className="theme-btn">Go to Checkout</Button>
          </Link>
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={12} md={12} lg={12} className ="shadow-lg">
          <Table hover bordered  responsive className="theme-table">
            <thead>
              <tr>
                <th>
                  <Form.Group>
                    <label className="checkbox path">
                      <input type="checkbox" label="Hide" />
                      <svg viewBox="0 0 21 21">
                        <path d="M5,10.75 L8.5,14.25 L19.4,2.3 C18.8333333,1.43333333 18.0333333,1 17,1 L4,1 C2.35,1 1,2.35 1,4 L1,17 C1,18.65 2.35,20 4,20 L17,20 C18.65,20 20,18.65 20,17 L20,7.99769186"></path>
                      </svg>
                    </label>
                  </Form.Group>
                </th>
                <th>Member Role</th>
                <th>Chapter Name</th>
                <th>Control Number</th>
                <th>Member Type</th>
                <th>Status</th>
                <th>Payment Amount</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {paymentData.map((item, i) => {
                return (
                  <tr key={i}>
                    <td className="py-3">
                      <Form.Group>
                        <label className="checkbox path">
                          <input type="checkbox" label="Hide" />
                          <svg viewBox="0 0 21 21">
                            <path d="M5,10.75 L8.5,14.25 L19.4,2.3 C18.8333333,1.43333333 18.0333333,1 17,1 L4,1 C2.35,1 1,2.35 1,4 L1,17 C1,18.65 2.35,20 4,20 L17,20 C18.65,20 20,18.65 20,17 L20,7.99769186"></path>
                          </svg>
                        </label>
                      </Form.Group>
                    </td>
                    <td className="py-3" >{item.role}</td>
                    <td>{item.chapter}</td>
                    <td className="py-3">{item.control_number}</td>
                    <td className="py-3">{item.type}</td>
                    <td className="py-3">{item.status}</td>
                    <td className="py-3">{item.payment}</td>
                    <td className="py-3">{item.amount}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col className="d-flex">
          <Link to="/">
            <Button className="theme-btn">Add to Checkout</Button>
          </Link>
        </Col>
      </Row>
      </Container>
    </>
  );
};
export default Payments;
